import { TLIconCalendarNoDate } from '@/components/design-system/atoms/icons/TLIconCalendarNoDate'
import { TLIconChart } from '@/components/design-system/atoms/icons/TLIconChart'
import { TLIconChat } from '@/components/design-system/atoms/icons/TLIconChat'
import { TLIconCog } from '@/components/design-system/atoms/icons/TLIconCog'
import { TLIconCycle } from '@/components/design-system/atoms/icons/TLIconCycle'
import { TLIconFacebook } from '@/components/design-system/atoms/icons/TLIconFacebook'
import { TLIconHistory } from '@/components/design-system/atoms/icons/TLIconHistory'
import { TLIconHome } from '@/components/design-system/atoms/icons/TLIconHome'
import { TLIconLayers } from '@/components/design-system/atoms/icons/TLIconLayers'
import { TLIconLinkedIn } from '@/components/design-system/atoms/icons/TLIconLinkedIn'
import { TLIconMagnifier } from '@/components/design-system/atoms/icons/TLIconMagnifier'
import { TLIconRocket } from '@/components/design-system/atoms/icons/TLIconRocket'
import { TLIconSettings } from '@/components/design-system/atoms/icons/TLIconSettings'
import { TLIconShield } from '@/components/design-system/atoms/icons/TLIconShield'
import { TLIconSuccess } from '@/components/design-system/atoms/icons/TLIconSuccess'
import { TLIconUser } from '@/components/design-system/atoms/icons/TLIconUser'
import { TLIconYoutube } from '@/components/design-system/atoms/icons/TLIconYoutube'

export const TLAtomsIcons = {
  CalendarNoDate: TLIconCalendarNoDate,
  Chart: TLIconChart,
  Cog: TLIconCog,
  Chat: TLIconChat,
  Cycle: TLIconCycle,
  Facebook: TLIconFacebook,
  History: TLIconHistory,
  Home: TLIconHome,
  Layers: TLIconLayers,
  LinkedIn: TLIconLinkedIn,
  Magnifier: TLIconMagnifier,
  Rocket: TLIconRocket,
  Settings: TLIconSettings,
  Shield: TLIconShield,
  Success: TLIconSuccess,
  User: TLIconUser,
  Youtube: TLIconYoutube
}
